import { inject, Injectable } from '@angular/core';

import { Subscription } from 'rxjs';
import { AppContextServiceService } from './app-context-service.service';
import { Database, get, ref } from '@angular/fire/database';


@Injectable({
    providedIn: "root"
})
export class CurrencyService {
    private db = inject(Database);
    currentCurrency = "SEK";
    subscriptions = new Subscription();

    availableCurrency = [
        { currency: "SEK", description: "Svenska kronor", symbol: "kr", infront: false, space: ' ' }, // Example 10 kr
        { currency: "NOK", description: "Norska kronor", symbol: "kr", infront: false, space: ' ' }, // Example 10 kr
        { currency: "DKK", description: "Dansk Krone", symbol: "kr", infront: false, space: ' ' }, // Example 10 kr
        { currency: "EUR", description: "Euro", symbol: "€", infront: true, space: '' }]; // Example €10
     currentRouteName: string | undefined;

    constructor(private app: AppContextServiceService) {
        this.currentRouteName = this.app.selectedUnit ?? undefined;
        if (this.currentRouteName) {
            get(ref(this.db, `Clients/${this.currentRouteName}/AppInfo/Context/currencyToUse`))
                .then(currencySnap => {
                    this.currentCurrency = currencySnap.val();
                });
        }
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    getAvailableCurrencies() {
        return this.availableCurrency;
    }

    setCurrency(currencyCode: string) {
        this.currentCurrency = currencyCode;
    }

    getCurrency(currencyCode: string) {
        let currencySettings = this.availableCurrency.filter(x => x.currency == currencyCode);

        if (currencySettings.length > 0)
            return currencySettings[0];
        else
            return this.availableCurrency[0];
    }
}